/**
 * Central registry of section style keys for page layout sections.
 *
 * These are for sections WITHIN page variants (e.g., a branded hero strip on the
 * homepage). Component-level styling (headers, cards, footers, odds buttons) is
 * handled by the global style slots on the tenant — don't duplicate those here.
 *
 * Used by:
 * - CMS field (Tenants → Style Slots → Section Styles dropdown)
 * - Page server components (to resolve styles by key)
 * - Layout components (to pick the right style from the sectionStyles map)
 *
 * Convention: "pageType:sectionName"
 * Add new entries here when a variant introduces a new styled section.
 */

// Homepage section keys
export const HOME_HERO = "home:hero";
export const HOME_MATCHDAY_BAND = "home:matchdayBand";
export const HOME_MATCHES = "home:matches";
export const HOME_STANDINGS = "home:standings";
export const HOME_ARTICLES = "home:articles";
export const HOME_LEADERS = "home:leaders";
export const HOME_STATS = "home:stats";
export const HOME_TEAMS = "home:teams";
export const HOME_COMPETITIONS = "home:competitions";

// Article section keys
export const ARTICLE_HERO = "article:hero";
export const ARTICLE_RELATED = "article:related";

// Video section keys
export const VIDEO_HERO = "video:hero";

// Entity page section keys (migrated from style slots)
export const TEAM_HEADER = "team:header";
export const PLAYER_HEADER = "player:header";
export const COMPETITION_HEADER = "competition:header";

// General fallback (applies to all headers when no page-specific key is set)
export const GENERAL_HEADER = "general:header";

// Page-specific header keys
export const MATCH_HEADER = "match:header";
export const STANDINGS_HEADER = "standings:header";
export const PREDICTOR_HEADER = "predictor:header";
export const ARTICLES_HEADER = "articles:header";
export const VIDEOS_HEADER = "videos:header";
export const COMPETITIONS_HEADER = "competitions:header";
export const COMPETITION_NEWS_HEADER = "competitionNews:header";
export const COMPETITION_VIDEOS_HEADER = "competitionVideos:header";
export const MATCHES_HEADER = "matches:header";
export const TEAMS_HEADER = "teams:header";
export const PLAYERS_HEADER = "players:header";
export const AUTHORS_HEADER = "authors:header";
export const AUTHOR_HEADER = "author:header";
export const SQUAD_HEADER = "squad:header";

// Footer section keys
export const FOOTER_DISCLAIMER = "footer:disclaimer";

/** All section key options for the CMS select field */
export const SECTION_KEY_OPTIONS: { label: string; value: string }[] = [
    { label: "Home — Hero", value: HOME_HERO },
    { label: "Home — Matchday Band", value: HOME_MATCHDAY_BAND },
    { label: "Home — Matches", value: HOME_MATCHES },
    { label: "Home — Standings", value: HOME_STANDINGS },
    { label: "Home — Articles", value: HOME_ARTICLES },
    { label: "Home — Leaders", value: HOME_LEADERS },
    { label: "Home — Stats", value: HOME_STATS },
    { label: "Home — Teams", value: HOME_TEAMS },
    { label: "Home — Competitions", value: HOME_COMPETITIONS },
    { label: "Article — Hero", value: ARTICLE_HERO },
    { label: "Article — Related Content", value: ARTICLE_RELATED },
    { label: "Video — Hero", value: VIDEO_HERO },
    { label: "Team — Header", value: TEAM_HEADER },
    { label: "Player — Header", value: PLAYER_HEADER },
    { label: "Competition — Header", value: COMPETITION_HEADER },
    { label: "General — Header (Default)", value: GENERAL_HEADER },
    { label: "Match — Header", value: MATCH_HEADER },
    { label: "Standings — Header", value: STANDINGS_HEADER },
    { label: "Predictor — Header", value: PREDICTOR_HEADER },
    { label: "Articles — Header", value: ARTICLES_HEADER },
    { label: "Videos — Header", value: VIDEOS_HEADER },
    { label: "Competitions — Header", value: COMPETITIONS_HEADER },
    { label: "Competition News — Header", value: COMPETITION_NEWS_HEADER },
    { label: "Competition Videos — Header", value: COMPETITION_VIDEOS_HEADER },
    { label: "Matches — Header", value: MATCHES_HEADER },
    { label: "Teams — Header", value: TEAMS_HEADER },
    { label: "Players — Header", value: PLAYERS_HEADER },
    { label: "Authors — Header", value: AUTHORS_HEADER },
    { label: "Author — Header", value: AUTHOR_HEADER },
    { label: "Squad — Header", value: SQUAD_HEADER },
    { label: "Footer — Disclaimer", value: FOOTER_DISCLAIMER },
];
